import React from "react";

const WavoipPhoneWidget = ({ 
  token, 
  position, 
  name, 
  country, 
  autoConnect, 
  onCallStarted, 
  onCallEnded, 
  onConnectionStatus, 
  onError 
}) => {
  // Componente básico para permitir compilação
  // TODO: Implementar funcionalidade completa
  return null;
};

export default WavoipPhoneWidget;

